import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VMenu, {
    attrs: {
      "open-on-hover": "",
      bottom: "",
      "offset-y": "",
      "close-on-content-click": false,
      transition: "scale-transition",
      "max-width": "800"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c("div", _vm._g(_vm._b({
          staticClass: "icon-wrapper"
        }, "div", attrs, false), on), [_c(VIcon, {
          staticClass: "fas fa-info",
          attrs: {
            color: "white",
            size: "0.60rem"
          }
        })], 1)];
      }
    }])
  }, [_c(VCard, [_c(VCardTitle, [_vm.modification.hasBeenDeleted ? _c("span", [_vm._v("Has been deleted")]) : _vm.modification.isPriceAddedManually && !_vm.modification.previousPriceUsdDefaultShippingIncludedPerBottle ? _c("span", [_vm._v(" Has been created manually ")]) : _c("span", [_vm._v("Last manual modification")])]), _vm.modification.previousPriceUsdDefaultShippingIncludedPerBottle ? _c(VCardText, [_vm.modification.isPriceAddedManually ? _c("div", [_c("span", [_c("i", {
    staticClass: "fas fa-user-plus mr-1"
  }), _c("span", {
    staticClass: "text-italic"
  }, [_vm._v("Has been created manually before")])])]) : _vm._e(), _c("div", [_c("span", [_c("i", {
    staticClass: "fas fa-history mr-2"
  }), _vm._v(" Previous price: ")]), _c("span", {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.modification.previousPriceUsdDefaultShippingIncludedPerBottle) + " US$ ")])]), _c("div", [_c("span", [_c("i", {
    staticClass: "fas fa-tag mr-2"
  }), _vm._v(" Original price: ")]), _c("span", {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.modification.originalPriceUsdDefaultShippingIncludedPerBottle) + " US$ ")])])]) : _vm._e(), _c(VCardText, [_c("div", {
    staticClass: "d-flex flex-column"
  }, [_c("div", [_c("span", [_c("i", {
    staticClass: "fas fa-user mr-2"
  }), _vm._v(" By: ")]), _c("span", {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.getUserInfos))])]), _c("span", {
    staticClass: "bold"
  }, [_c("i", {
    staticClass: "fas fa-envelope mr-2"
  }), _vm._v(" " + _vm._s(_vm.modification.lastModifiedByUser.login) + " ")])]), _c("div", {
    staticClass: "mt-2"
  }, [_c("span", [_c("i", {
    staticClass: "fas fa-clock mr-2"
  }), _vm._v(" At: ")]), _c("span", {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.returnLocalDateTime))])])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };